




























































import { defineComponent, reactive, computed, ref, watch, getCurrentInstance } from '@vue/composition-api';
import i18n, { i18n_t } from '@/locales/i18n';
import { passwordReg } from '@/renderer/components/user/compositions/userValidator';
import tips from '@/renderer/scripts/utils/tips';
export default defineComponent({
  props: {
    // 展示表单的字段，默认只展示新密码,实际场景按需展示账号或老密码
    showFormItems: {
      type: Array,
      default: ['newPassword', 'cfmPassword'],
    },
    btnPosition: {
      type: String,
      default: 'center',
    },
    labelWidth: {
      type: Number,
      default: 70,
    },
  },
  setup(props, context) {
    /**
     * tdesign现有form校验不太能支持需求，这里手动实现了校验
     * 组件有3种形态：
     * 1、首次登录需要修改密码：只需要输入新密码+确认新密码
     * 2、自己修改密码：需要输入旧密码+新密码+确认新密码
     * 3、重置密码：需要输入账号+新密码+确认新密码
     * */

    const showAccountName = computed(() => props.showFormItems.includes('accountName'));
    const showOldPassword = computed(() => props.showFormItems.includes('oldPassword'));

    // 为了初始化时不触发校验，这里标记字段有没有被改过
    const accountNameChanged = ref(false);
    const oldPwdChanged = ref(false);
    const newPwdChanged = ref(false);
    const cfmPwdChanged = ref(false);
    const formData = reactive({
      accountName: '',
      oldPassword: '',
      newPassword: '',
      cfmPassword: '',
    });

    // 账号不能为空
    const accountNameRequired = computed(() => {
      // 不需要输入账号时
      if (!showAccountName.value) {
        return true;
      }
      return !accountNameChanged.value ? true : formData.accountName;
    });
    // 老密码不能为空
    const oldPwdRequired = computed(() => {
      // 不需要输入原密码时
      if (!showOldPassword.value) {
        return true;
      }
      return !oldPwdChanged.value ? true : formData.oldPassword;
    });
    // 新密码不能等于老密码
    const newPwdEqualsOldPwd = computed(() => {
      // 不需要输入原密码时
      if (!showOldPassword.value) {
        return true;
      }
      if (!oldPwdChanged.value && !newPwdChanged.value) {
        return true;
      }
      return formData.oldPassword && formData.newPassword ? formData.newPassword !== formData.oldPassword : true;
    });
    // 两次输入的密码必须一致
    const newPwdsNotSame = computed(() => {
      if (!newPwdChanged.value && !cfmPwdChanged.value) {
        return true;
      }
      return formData.newPassword && formData.cfmPassword ? formData.newPassword === formData.cfmPassword : true;
    });
    // 新密码长度符合条件
    const newPwdLengthNotValidated = computed(() => {
      if (!newPwdChanged.value) {
        return true;
      }
      return formData.newPassword ? formData.newPassword.length >= 8 && formData.newPassword.length <= 100 : true;
    });
    // 确认密码长度符合条件
    const newPwdCfmLengthNotValidated = computed(() => {
      if (!cfmPwdChanged.value) {
        return true;
      }
      return formData.cfmPassword ? formData.cfmPassword.length >= 8 && formData.cfmPassword.length <= 100 : true;
    });
    // 新密码格式不正确
    const newPwdNotFormatted = computed(() => {
      if (!newPwdChanged.value) {
        return true;
      }
      return formData.newPassword ? passwordReg.test(formData.newPassword) : true;
    });
    // 确认密码格式正确
    const newPwdCfmNotFormatted = computed(() => {
      if (!cfmPwdChanged.value) {
        return true;
      }
      return formData.cfmPassword && passwordReg.test(formData.cfmPassword);
    });
    const validated = computed(() => {
      if (!oldPwdChanged.value && !newPwdChanged.value && !cfmPwdChanged.value) {
        return true;
      }
      return (
        oldPwdRequired.value &&
        newPwdEqualsOldPwd.value &&
        newPwdsNotSame.value &&
        newPwdNotFormatted.value &&
        newPwdCfmNotFormatted.value &&
        newPwdLengthNotValidated.value &&
        newPwdCfmLengthNotValidated.value
      );
    });
    const required = computed(() => {
      const accountNameRequired = showAccountName.value ? formData.accountName : true;
      const oldNameRequired = showOldPassword.value ? formData.oldPassword : true;
      return accountNameRequired && oldNameRequired && formData.newPassword && formData.cfmPassword;
    });
    const saveDisabled = computed(() => !validated.value || !required.value);
    const saved = ref(false);
    const methods = {
      onPasteCfmPassword() {
        tips.warning(i18n_t('请手动输入密码确认，不支持粘贴操作'));
        return false;
      },
      submit() {
        if (!validated.value || !required.value) return;
        // 这里抛出没有encode的表单内容 统一交给handler完成encode
        context.emit('password-saved', formData);
      },
    };

    // 任意修改后触发校验
    watch(
      () => formData.accountName,
      () => {
        accountNameChanged.value = true;
      },
    );
    watch(
      () => formData.oldPassword,
      () => {
        oldPwdChanged.value = true;
      },
    );
    watch(
      () => formData.newPassword,
      () => {
        newPwdChanged.value = true;
      },
    );
    watch(
      () => formData.cfmPassword,
      () => {
        cfmPwdChanged.value = true;
      },
    );
    return {
      showAccountName,
      showOldPassword,
      accountNameRequired,
      oldPwdRequired,
      newPwdEqualsOldPwd,
      newPwdsNotSame,
      newPwdNotFormatted,
      newPwdCfmNotFormatted,
      newPwdLengthNotValidated,
      newPwdCfmLengthNotValidated,
      formData,
      saveDisabled,
      saved,
      ...methods,
    };
  },
});
